import React, { useCallback } from "react"

import { useChatDrawer } from "./ChatDrawerContext"
import { LoadingIndicator } from "./LoadingIndicator"
import { useHandleMessageFromChildFrame } from "./useHandleMessageFromChildFrame"
import { useStableIframeSrcAttributeAndSyncFragmentRoute } from "./useStableIframeSrcAttributeAndSyncFragmentRoute"

export function ChatIframe() {
  const [isLoading, setIsLoading] = React.useState(true)
  const { closeDrawer, focusDrawerContentIfStillExpected, route, setRoute } =
    useChatDrawer()

  const handleDrawerClose = useCallback(() => {
    closeDrawer()
  }, [closeDrawer])

  const iframeSrc = useStableIframeSrcAttributeAndSyncFragmentRoute({
    onInternalPathChange: setRoute,
    route,
  })

  useHandleMessageFromChildFrame(handleDrawerClose, {
    messageType: "CLOSE_DRAWER",
  })

  return (
    <React.Fragment>
      <LoadingIndicator isLoading={isLoading} />
      <iframe
        onLoad={(event) => {
          setIsLoading(false)
          focusDrawerContentIfStillExpected(event.currentTarget)
        }}
        src={iframeSrc}
        title="Chat"
        style={{
          backgroundColor: "white",
          border: "none",
          height: "100%",
          width: "100%",
          zIndex: "1",
        }}
      />
    </React.Fragment>
  )
}
